import { render } from "./ModernSnackbar.vue?vue&type=template&id=c4fbaee4&scoped=true"
import script from "./ModernSnackbar.vue?vue&type=script&lang=js"
export * from "./ModernSnackbar.vue?vue&type=script&lang=js"

import "./ModernSnackbar.vue?vue&type=style&index=0&id=c4fbaee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fbaee4"]])

export default __exports__